.modalAlert {
    align-items: center;
    margin-bottom: 10px;
}

.slotGrid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    margin-top: 8px;
}
